import React from 'react';
import { Surgerie } from 'types/surgerie';
import history from 'services/history';
import DataGridList from 'components/data-grid/DataGridList';
import RowActionButton from 'components/data-grid/RowActionButton';
import { surgerieClosedTableTemplate } from '../../template/surgerieClosedTableTemplate';
import SurgerieClosedMenu from '../menu/SurgerieClosedMenu';
import { useSurgerie } from '../../hooks/useSurgerie';

type SurgerieClosedListTableProps = {
  surgeries: Surgerie[];
};

const SurgerieClosedListTable: React.FC<SurgerieClosedListTableProps> = ({ surgeries }) => {
  const { anchorEl, setAnchorEl, setSelectedSurgerie } = useSurgerie();

  return (
    <>
      {anchorEl && <SurgerieClosedMenu anchorEl={anchorEl} />}

      <DataGridList
        template={surgerieClosedTableTemplate}
        rows={surgeries}
        getRowId={row => row.id_int}
        renderCells={{
          action: surgerie => (
            <RowActionButton
              onOpen={anchor => {
                setAnchorEl(anchor);
                setSelectedSurgerie(surgerie);
              }}
            />
          ),
        }}
        onRowClick={row => history.push(`/surgeries/${row.id_int}`)}
        fileName="cirurgias_fechadas"
        sheetName="Cirurgias fechadas"
      />
    </>
  );
};

export default SurgerieClosedListTable;
